import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { TeamProvider } from './team/TeamContext';
import { AuthGuard, TeamAdminGuard } from './auth/AuthGuard';
import Layout from './shared/components/Layout';
import LandingPage from './landing/LandingPage';
import LoginPage from './auth/LoginPage';
import RegisterPage from './auth/RegisterPage';
import ProfilePage from './auth/ProfilePage';
import FlashcardApp from './apps/flashcards/FlashcardApp';
import MatrixApp from './apps/matrix/MatrixApp';
import CommandDrillApp from './apps/commandDrill/CommandDrillApp';
import ExamSimApp from './apps/examSim/ExamSimApp';
import ProgressPage from './progress/ProgressPage';
import LeaderboardPage from './team/LeaderboardPage';
import AdminDashboard from './team/AdminDashboard';
import TeamManager from './team/TeamManager';

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <TeamProvider>
          <Routes>
            {/* Public routes (no layout, no auth) */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />

            {/* Protected routes (with layout and auth) */}
            <Route path="/*" element={
              <AuthGuard>
                <Layout>
                  <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/progress" element={<ProgressPage />} />
                    <Route path="/leaderboard" element={<LeaderboardPage />} />
                    <Route path="/teams" element={<TeamManager />} />
                    <Route path="/profile" element={<ProfilePage />} />
                    <Route path="/admin" element={
                      <TeamAdminGuard><AdminDashboard /></TeamAdminGuard>
                    } />
                    <Route path="/flashcards/*" element={<FlashcardApp />} />
                    <Route path="/matrix/*" element={<MatrixApp />} />
                    <Route path="/drill/*" element={<CommandDrillApp />} />
                    <Route path="/exam/*" element={<ExamSimApp />} />
                  </Routes>
                </Layout>
              </AuthGuard>
            } />
          </Routes>
        </TeamProvider>
      </AuthProvider>
    </Router>
  );
}
